import { css } from 'styled-components';

const HeaderReset = css`
  font-weight: 400;
  color: ${p => p.theme.carvana.blue.dark};
  font-size: 16px;
  font-family: ${p => p.theme.typography.fontFamily};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  p {
    margin-top: 0;
    margin-bottom: 16px;
    line-height: 1.5;
  }
  input {
    font-size: inherit;
  }
  input,
  button,
  select,
  textarea {
    font-family: inherit;
    line-height: inherit;
  }
  ul {
    list-style: disc;
    padding-inline-start: 40px;
  }
  li {
    list-style-type: disc;
  }
  b,
  strong {
    font-weight: bolder;
  }
`;

export default HeaderReset;
